var _excluded = ["profile", "created_at", "body", "subject", "badgeText", "id", "published"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useState } from 'react';
import { useQuestion } from '../hooks/useQuestion';
import { useUser } from '../hooks/useUser';
import Avatar from './Avatar';
import Days from './Days';
import Markdown from './Markdown';
export default function Reply(_ref) {
  var _user$profile;

  var profile = _ref.profile,
      created_at = _ref.created_at,
      body = _ref.body,
      subject = _ref.subject,
      badgeText = _ref.badgeText,
      id = _ref.id,
      published = _ref.published,
      other = _objectWithoutPropertiesLoose(_ref, _excluded);

  var question = useQuestion();
  var questionAuthorId = question.questionAuthorId,
      resolved = question.resolved,
      resolvedBy = question.resolvedBy,
      handleResolve = question.handleResolve,
      handlePublish = question.handlePublish,
      handleReplyDelete = question.handleReplyDelete;

  var _useState = useState(false),
      confirmDelete = _useState[0],
      setConfirmDelete = _useState[1];

  var user = useUser();
  var isModerator = user === null || user === void 0 ? void 0 : user.isModerator;
  var isAuthor = (user === null || user === void 0 ? void 0 : (_user$profile = user.profile) === null || _user$profile === void 0 ? void 0 : _user$profile.id) === questionAuthorId;

  var handleDelete = function handleDelete(e) {
    e.stopPropagation();

    if (confirmDelete) {
      handleReplyDelete(id);
    } else {
      setConfirmDelete(true);
    }
  };

  var handleContainerClick = function handleContainerClick() {
    setConfirmDelete(false);
  };

  return /*#__PURE__*/React.createElement("div", _extends({}, other, {
    onClick: handleContainerClick
  }), /*#__PURE__*/React.createElement("div", {
    className: "squeak-post-author"
  }, /*#__PURE__*/React.createElement(Avatar, {
    image: profile === null || profile === void 0 ? void 0 : profile.avatar
  }), /*#__PURE__*/React.createElement("strong", {
    className: "squeak-author-name"
  }, (profile === null || profile === void 0 ? void 0 : profile.first_name) || 'Anonymous'), badgeText && /*#__PURE__*/React.createElement("span", {
    className: "squeak-author-badge"
  }, badgeText), /*#__PURE__*/React.createElement(Days, {
    created: created_at
  }), resolved && resolvedBy === id && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "squeak-resolved-badge"
  }, "Solution"), (isAuthor || isModerator) && /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return handleResolve(false);
    },
    className: "squeak-undo-resolved"
  }, "Undo"))), /*#__PURE__*/React.createElement("div", {
    className: "squeak-post-content"
  }, subject && /*#__PURE__*/React.createElement("h3", null, subject), /*#__PURE__*/React.createElement(Markdown, null, body), !subject && /*#__PURE__*/React.createElement("div", {
    className: "squeak-reply-action-buttons"
  }, !resolved && (isAuthor || isModerator) && /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return handleResolve(true, id);
    },
    className: "squeak-resolve-button"
  }, "Mark as solution"), isModerator && /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return handlePublish(id, !published);
    },
    className: "squeak-publish-button"
  }, published ? 'Unpublish' : 'Publish'), isModerator && /*#__PURE__*/React.createElement("button", {
    onClick: handleDelete,
    className: "squeak-delete-button"
  }, confirmDelete ? 'Click again to confirm' : 'Delete'))));
}